var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypescriptLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "typescript-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "typescript-logo_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.706 0.00363159H3.31209H3.31195C0.509519 0.00366631 0 0.0036726 0 2.5514V115.672C0 120.004 0.25462 120.004 4.07629 120.004H116.809C120.004 120.004 120.004 119.767 120 116.776V116.771C120 116.663 119.999 116.552 119.999 116.437V2.42043C119.999 0.127322 119.999 0.00363159 117.706 0.00363159ZM68.2798 55.2902H26.4966V64.9718H41.7831V109.813H52.9933V64.9718H68.2798V55.2902ZM98.8529 69.0482L107.515 63.1884C105.732 60.131 98.3435 54.5258 93.7575 54.5259H89.9359C82.2927 54.5259 76.4325 62.424 75.6683 65.7361C74.9041 69.0482 74.9039 71.5959 75.6683 74.3985C76.4328 77.201 80.2543 81.5322 82.5472 82.8061L97.3242 90.4495C98.8529 91.2138 100.891 95.4109 97.3242 98.6024C95.5408 100.198 88.6619 101.405 84.8402 98.0928L80.7638 93.5068L71.8467 98.8571L75.6683 104.462C80.2544 109.558 85.3499 110.067 91.9741 110.067H96.8147C101.401 110.067 107.006 104.717 108.789 101.405C110.573 98.0927 110.457 94.5259 109.808 90.959C109.16 87.3921 107.006 83.5705 101.91 80.7679L89.1714 73.6342C84.5855 70.8316 85.6047 65.9908 89.1715 64.717C89.1715 64.717 90.4454 64.4622 91.2098 64.4622C91.8874 64.4622 92.9932 64.4622 93.5027 64.717C93.5027 64.717 97.3244 66.7552 98.8529 69.0482Z",
    fill: "url(#paint0_linear_21_514)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_514",
    x1: -0.00000528435,
    y1: -12.99,
    x2: 124.841,
    y2: 135.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352498,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553998,
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescriptLogo);
export default __webpack_public_path__ + "static/media/typescript-logo.75ed91b4eca6c40a619a1ac394692bc3.svg";
export { ForwardRef as ReactComponent };